export const serverURL = process.env.REACT_APP_SERVER_URL ?? 'http://localhost:8000'
export const nextURL = process.env.REACT_APP_NEXT_URL
export const hyperpayURL = 'https://eu-test.oppwa.com'
